<template>
    <div id="config-contributors">
        <FilterView placeholder="Chercher un contributeur..." v-model="searchTerm"></FilterView>
        <Modal
            v-if="showEdit"
            v-model="contributor"
            @dismiss="showEdit = false"
            @close="handleClose"
        />
        <h2 class="title">Contributeurs</h2>
        <LoadingDots v-if="isLoading" />
        <CardPager>
            <ContributorCard
                v-for="item in filtered"
                :key="item.id"
                :item="item"
                :handleEdit="handleEdit"
            />
        </CardPager>
    </div>
</template>

<script>
import FilterView from '@/components/config/Filter';
import LoadingDots from '@/components/LoadingDots';
import CardPager from '@/components/CardPager';
import ContributorCard from '@/components/config/ContributorCard';
import Modal from '@/components/config/ModalContributor';

export default {
    data() {
        return {
            contributors: [],
            searchTerm: null,
            isLoading: true,
            showEdit: false,
        };
    },
    computed: {
        filtered() {
            if (this.searchTerm) {
                const re = new RegExp(this.searchTerm, 'i');
                return this.contributors.filter((c) => re.test(c.name));
            }
            return this.contributors;
        },
    },
    mounted() {
        this._load();
    },
    methods: {
        _load() {
            this.$http
                .get('/api/contributor')
                .then(
                    (response) => {
                        // success callback
                        this.contributors = response.body;
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => (this.isLoading = false));
        },
        _getContributor(id) {
            return { ...this.contributors.find((c) => c.id === id) };
        },
        handleEdit(item) {
            this.contributor = this._getContributor(item);
            this.showEdit = true;
        },
        handleClose() {
            // save it
            this.$http
                .put(`/api/contributor/${this.contributor.id}`, this.contributor)
                .then(() => {
                    this.group = null;
                    this.isLoading = true;
                    this.contributors.splice(0);
                    this.showEdit = false;
                    this._load();
                })
                .catch();
        },
    },
    components: {
        FilterView,
        LoadingDots,
        CardPager,
        ContributorCard,
        Modal,
    },
};
</script>

<style lang="scss"></style>
